/**
 * useReauth — W1.7
 *
 * Re-Auth-Token-Management. Token lebt ausschliesslich in einem useRef —
 * KEIN localStorage, KEIN sessionStorage, KEIN Cookie.
 * Damit ist kein Re-Render moeglich, der den Token nach aussen leakt.
 */
import { useRef } from 'react'
import { claimApi } from '../api/claimApi'

export function useReauth() {
  // Kein useState — kein Re-Render-Leak. Ref fuer kurzlebigen Token.
  const tokenRef = useRef<string | null>(null)

  const authenticate = async (password: string): Promise<boolean> => {
    const { data, error } = await claimApi.reauth(password)
    if (error || !data?.reauth_token) return false
    tokenRef.current = data.reauth_token
    return true
  }

  const getToken = () => tokenRef.current

  const clearToken = () => {
    tokenRef.current = null
  }

  return { authenticate, getToken, clearToken }
}
